import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import TimaticWidget from "../timatic-widget/timatic-widget-component"
import { isMobile } from "react-device-detect"
import { trackTravelPlanner } from "../../helpers/tracking"

export class ItineraryEssentialInfo extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      accordionOpen: false,
    }

    this.showHideContent = this.props.showHideContent.bind(this)
  }

  setWidgetInputData() {
    if (
      window.timaticWidgetInputData &&
      !window.timaticWidgetInputData.selectedDestinationAirportCode &&
      !window.timaticWidgetInputData.selectedDepartureAirportCode
    ) {
      window.timaticWidgetInputData.selectedDestinationAirportCode = this.state.flightInfo.IataDestination
      window.timaticWidgetInputData.selectedDepartureAirportCode = "CPH"
    }
  }

  handleWidgetAccordionClick = (e) => {
    this.setWidgetInputData()
    this.showHideContent(e, ".contentWrapper")
    this.handleAccordionTracking()
  }

  handleAccordionTracking = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen }, () => {
      trackTravelPlanner("track-event.generic", `covid-19 - ${this.state.accordionOpen ? "expand" : "collapse"}`, "", this.state.flightInfo.FlightId)
    })
  }

  render() {
    if (this.props.block) {
      const blockColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
      if (this.props.block.widgetBlock?.length > 0) {
        return this.props.block.widgetBlock.map((block, i) => {
          return (
            <div
              key={i}
              id={"timatic-anchor"}
              className={`departure-info__essentials__infoaccordion no-float foldable ${blockColor ? blockColor : ""}`}
            >
              <h5 className={"pointer"} onClick={(e) => this.handleWidgetAccordionClick(e)}>
                {this.props.block.headline || ""}
              </h5>
              <div className="contentWrapper show-hide">
                {this.props.block.text ? (
                  <div className="widget-block-covid">
                    <div className="grid">
                      <div className="widget-block-covid__left grid-item col--12 col-sm--6">
                        <div className="inner">
                          <div className="widget-block-covid__info" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></div>
                          <div
                            className="widget-block-covid__info__extra"
                            dangerouslySetInnerHTML={{ __html: this.props.block.legalText || "" }}
                          ></div>
                        </div>
                      </div>
                      <div className={`widget-block-covid__right grid-item col--12 col-sm--6 ${isMobile ? "no-padding" : ""}`}>
                        <div className="inner">
                          <TimaticWidget flightInfo={this.state.flightInfo} />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={"essential-info-widget-wrapper"}>
                    <div className={"grid"}>
                      <div className={"inner"}>
                        <TimaticWidget flightInfo={this.state.flightInfo} />
                      </div>
                    </div>
                  </div>
                )}
                {this.props.block.text ? (
                  ""
                ) : (
                  <div className={"legal-text"} dangerouslySetInnerHTML={{ __html: this.props.block.legalText || "" }}></div>
                )}
              </div>
            </div>
          )
        })
      } else {
        return (
          <div className={`departure-info__essentials__infoaccordion foldable ${blockColor ? blockColor : ""}`}>
            <h5
              className={"pointer"}
              onClick={(e) => {
                this.showHideContent(e, ".contentWrapper")
                this.handleAccordionTracking()
              }}
            >
              {this.props.block.headline}
            </h5>
            <div className="contentWrapper show-hide grid">
              {this.props.block.uspContainerBlocks &&
                this.props.block.uspContainerBlocks.map((uspContainer, i) => {
                  return <ItineraryUspContainer key={`uspContainer${i}`} block={uspContainer} />
                })}
            </div>
          </div>
        )
      }
    }
    return ""
  }
}

class ItineraryUspContainer extends Component {
  gotIcons(blocks) {
    return blocks && blocks.every((b) => b.svgIcon.length > 0 || b.iconUpload)
  }

  render() {
    if (this.props.block) {
      const gotIcons = this.gotIcons(this.props.block.uspBlocks)
      return (
        <div className="grid-item col--12 col-sm--4">
          <h6>{this.props.block.headline}</h6>
          <ul className={`${gotIcons ? "wicons" : ""}`}>
            {this.props.block.uspBlocks &&
              this.props.block.uspBlocks.map((uspBlock, i) => {
                const iconUploaded = gotIcons && uspBlock.iconUpload
                const hasSvg = gotIcons && uspBlock.svgIcon.length > 0
                const icon = iconUploaded ? uspBlock.iconUpload : hasSvg ? SelectionFactoryHelper.getFromSelectionFactory(uspBlock.svgIcon) : ""
                return (
                  <li key={`usp${i}`}>
                    {icon && iconUploaded ? <img className={"icon"} src={icon} alt="" /> : icon && hasSvg ? <Svg iconName={icon} /> : ""}
                    <span dangerouslySetInnerHTML={{ __html: uspBlock.uspText }}></span>
                  </li>
                )
              })}
          </ul>
        </div>
      )
    }
    return ""
  }
}
